












import Vue from 'vue';
import {
  mapState,
  mapActions
} from 'vuex';
import store from '../store/index';
import { getQueryVariable } from '../common/common';
import OriginalTextMark from '../components/OriginalTextMark.vue';
import ReportHeader from '../components/ReportHeader.vue';
import ReportFooter from '../components/ReportFooter.vue';
import CheckInfo from '../components/CheckInfo.vue';
import CheckResult from '../components/CheckResult.vue';
import CheckLimit from '../components/CheckLimit.vue';
import CheckResultDetail from '../components/CheckResultDetail.vue';
import Signature from '../components/Signature.vue';

export default Vue.extend({
  name: 'Preservation',
  computed: mapState({
    reportType: (state: any) => store.getters.getReportType,
    checkInfo: (state: any) => store.getters.getCheckInfo
  }),
  components: {
    OriginalTextMark,
    ReportHeader,
    ReportFooter,
    CheckInfo,
    CheckResult,
    CheckLimit,
    CheckResultDetail,
    Signature
  },
  data() {
    return {
      checkResult: {}
    };
  },
  methods: {
    // 获取检测报告数据
    getData() {
      if (JSON.stringify(this.checkInfo) === '{}') {
        this.$store.dispatch('setCheckInfo');
      }
    }
  },
  mounted() {
    this.getData();
  }
});
